// Sample Object for three level filter. First level is Make, second is model and third is year. Last/Third filter should be an array.
// First value is Make, second is model and this is year
let makeObject = {
  Acura: {
    ILX: ["2015", "2014", "2013"],
    Integra: ["2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994"],
    RL: ["2008", "2007", "2006", "2005"],
    RSX: ["2006", "2005", "2004", "2003", "2002"],
    TL: ["2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999"],
    TLX: ["2016", "2015"],
    TSX: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003"],
  },
  Audi: {
    A4: ["2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002"],
    A6: ["2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996"],
  },
  BMW: {
    "3-Series 2DR": ["2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000"],
    "3-Series 4DR": ["2011", "2010", "2009", "2008", "2007", "2006"],
    "318TI": ["1998", "1997", "1996", "1995"],
    "5-Series": ["2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999"],
    Z4: ["2008", "2007", "2006", "2005", "2004", "2003", "2002"],
  },
  Buick: {
    Century: ["2004", "2003", "2002", "2001", "2000", "1999", "1998"],
    Lacrosse: ["2013", "2012", "2011", "2010"],
    Lucerne: ["2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    Regal: ["2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997"],
  },
  Cadillac: {
    ATS: ["2015", "2014", "2013"],
    "CTS Coupe": ["2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "CTS Sedan": ["2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    Catera: ["2002", "2001", "2000", "1999", "1998", "1997"],
    "Deville DTS": ["2011", "2010", "2009", "2008", "2007", "2006"],
    "El Dorado": ["2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992"],
    Escalade: ["2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2004", "2003", "2002"],
    STS: ["2011", "2010", "2009", "2008", "2007", "2006", "2005"],
  },
  Chevrolet: {
    Aveo: ["2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    Beretta: ["1995", "1994", "1993", "1992", "1991", "1990", "1989"],
    C1500: ["2006", "2005", "2004", "2003"],
    Camaro: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993"],
    "Camaro Z28": ["2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    "Cavalier Z24": ["2002", "2001", "2000"],
    "Cobalt 2DR": ["2010", "2009", "2008", "2007", "2006", "2005"],
    "Cobalt 4DR": ["2010", "2009", "2008", "2007", "2006", "2005"],
    "Corvette C5": ["2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997"],
    "Corvette C6": ["2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
    "Corvette C7": ["2016", "2015", "2014"],
    Cruze: ["2015", "2014", "2013", "2012", "2011"],
    Equinox: ["2013", "2012", "2011", "2010"],
    HHR: ["2011", "2010", "2009", "2008", "2007", "2006"],
    Impala: ["2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000"],
    Malibu: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    "Malibu Maxx": ["2007", "2006", "2005", "2004"],
    Prizm: ["2002", "2001", "2000", "1999", "1998"],
    SSR: ["2006", "2005", "2004"],
    Silverado: ["2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    Suburban: ["2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "1999", "1998", "1997", "1996", "1995", "1994"],
    Tahoe: ["2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    Trailblazer: ["2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002"],
  },
  Chrysler: {
    200: ["2016", "2015", "2014", "2013", "2012", "2011"],
    300: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
    "300M": ["2004", "2003", "2002", "2001", "2000", "1999"],
    Aspen: ["2009", "2008", "2007", "2006"],
    Concorde: ["1997", "1996", "1995", "1994", "1993"],
    "PT Cruiser": ["2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001"],
    Sebring: ["2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995"],
    "Town and Country": ["2007", "2006", "2005", "2004", "2003", "2002", "2001"],
  },
  Dodge: {
    Avenger: ["2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "1996", "1995"],
    Caliber: ["2011", "2010", "2009", "2008", "2007", "2006"],
    Caravan: ["2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001"],
    Challenger: ["2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    Charger: ["2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    "Charger 500": ["2010", "2009", "2008", "2007", "2006"],
    "Charger Daytona": ["2010", "2009", "2008", "2007", "2006"],
    Dart: ["2015", "2014", "2013"],
    Durango: ["2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    Intrepid: ["2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993"],
    Neon: ["2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994"],
    Nitro: ["2011", "2010", "2009", "2008", "2007"],
    Ram: ["2015", "2014", "2008", "2007", "2006", "2005", "2004", "2003", "2002"],
    Stratus: ["2005", "2004", "2003", "2002", "2001"],
  },
  Fiat: {
    500: ["2015", "2014", "2013", "2012"],
  },
  Ford: {
    "Five Hundred": ["2007", "2006", "2005"],
    Contour: ["2001", "2000", "1999", "1998"],
    "Crown Victoria": ["2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998"],
    Escape: ["2012", "2011", "2010", "2009", "2008"],
    Expedition: ["2001", "2000", "1999", "1998", "1997"],
    Explorer: ["2007", "2006", "2005", "2004", "2003", "2002"],
    Flex: ["2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    "F-150": ["2008", "2007", "2006", "2005", "2004"],
    Fiesta: ["2015", "2014", "2013", "2012", "2011"],
    Focus: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000"],
    Fusion: ["2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    "F-150 Lightning": ["2004", "2003", "2002", "2001", "2000", "1999"],
    Mustang: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
    "Mustang GT": ["2004", "2003", "2002", "2001", "2000", "1999"],
    "Mustang GT350R": ["2016", "2015"],
    "Mustang GT500": ["2009", "2008", "2007", "2006", "2005"],
    Taurus: ["2012", "2011", "2010", "2009", "2008"],
    Thunderbird: ["1997", "1996", "1995", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989"],
  },
  GMC: {
    Denali: ["1999", "1998", "1997", "1996", "1995", "1996", "1995", "1994"],
    Envoy: ["2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002"],
    Sierra: ["2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    Tahoe: ["2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2005", "2004", "2003", "2002"],
    Yukon: ["2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2005", "2004", "2003", "2002", "1999", "1998", "1997", "1996", "1995", "1996", "1995", "1994"],
  },
  Honda: {
    "Accord 2DR": [
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1996",
      "1995",
      "1994",
    ],
    "Accord 4DR": [
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1996",
      "1995",
      "1994",
    ],
    CRV: ["2011", "2010", "2009", "2008", "2007"],
    "Civic 2DR": [
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1996",
    ],
    "Civic 4DR": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1996"],
    "Del Sol": ["1997", "1996", "1995", "1996", "1995", "1994", "1993"],
    Element: ["2011", "2010", "2009", "2008", "2007", "2005", "2004", "2003"],
    S2000: ["2007", "2005", "2004", "2003", "2002", "2001", "2000"],
  },
  Hummer: {
    H2: ["2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    H3: ["2010", "2009", "2008", "2007", "2006", "2005"],
  },
  Hyundai: {
    Accent: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    Azera: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    Elantra: ["2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2006", "2005", "2004"],
    "Elantra Touring": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    "Genesis 2DR": ["2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    "Genesis 4DR": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    "Genesis Hood Scoop": ["2014", "2013", "2012", "2011", "2010", "2009"],
    "Santa Fe": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001"],
    Sonata: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    Tiburon: ["2002", "2001", "2000"],
    "Tiburon GT-V6": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    Tucson: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
  },
  Infiniti: {
    G20: ["2002", "2001", "2000", "1999"],
    "G35 2DR": ["2007", "2006", "2005", "2004", "2003"],
    "G35 4DR": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "G37 2DR": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    "G37 4DR": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "G37 Side Scoops": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    M35: ["2010", "2009", "2008", "2007", "2006"],
    M37: ["2016", "2015", "2014", "2013", "2012", "2011"],
    M45: ["2010", "2009", "2008", "2007", "2006"],
    Q50: ["2016", "2015", "2014"],
    Q70: ["2016", "2015"],
    QX56: ["2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    I30: ["2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1996"],
    I35: ["2004", "2003", "2002", "2001", "2000"],
  },
  Jaguar: {
    "S-Type R": ["2004", "2003", "2002", "2001", "2000"],
    XF: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
  },
  Jeep: {
    "Grand Cherokee": ["2010", "2009", "2008", "2007", "2006", "2005"],
    Liberty: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    Patriot: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
  },
  Kia: {
    Amanti: ["2009", "2008", "2007", "2006", "2005", "2004"],
    Cadenza: ["2016", "2015", "2014"],
    "Forte Koup": ["2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    "Forte Koup-R": ["2013", "2012", "2011", "2010"],
    "Forte Sedan": ["2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    Optima: ["2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001"],
    Rio: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    Rondo: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    Sedona: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002"],
    Soul: ["2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    Sorento: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    Spectra: ["2009", "2008", "2007", "2006", "2005", "2004"],
    Sportage: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
  },
  "Land Rover": {
    "Range Rover": ["2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
    "Range Rover Sport": ["2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
  },
  Lexus: {
    ES: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002"],
    GS: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    GS300: ["2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998"],
    GS400: ["2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998"],
    GX470: ["2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    IS: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    IS250: ["2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    IS300: ["2005", "2004", "2003", "2002", "2001"],
    LS460: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    LX470: ["2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999"],
    RC: ["2015"],
    RX300: ["2003", "2002", "2001", "2000", "1999"],
  },
  Lincoln: {
    Continental: ["1997", "1996", "1995"],
    LS: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000"],
    MKS: ["2014", "2013", "2012", "2011", "2010"],
    MKZ: ["2016", "2015", "2014", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    Navigator: ["2001", "2000", "1999", "1998", "1997"],
    "Navigator Hood Scoop": ["2010", "2009", "2008", "2007"],
    Zephyr: ["2012", "2011", "2010", "2009", "2008", "2007", "2006"],
  },
  Mazda: {
    "CX-7": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    MPV: ["2005", "2004", "2003", "2002", "2001", "2000"],
    "Mazda 3": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    "Mazda 5 Hatchback": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    "Mazda 6": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "Mazda 626": ["2002", "2001", "2000", "1999", "1998"],
    "Miata MX-5": ["2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    "Protege MP3": ["2003", "2002", "2001", "2000", "1999"],
    "RX-8": ["2008", "2007", "2006", "2005", "2004"],
    Tribute: ["2012", "2011", "2010", "2009", "2008"],
  },
  "Mercedes Benz": {
     "200E": [
      "1993",
      "1992"
    ],
    "C180": [
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993"
    ],
    "C180 CGI": [
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007"
    ],
    "C180K": [
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002"
    ],
    "C200": [
      "2022",
      "2021",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993"
    ],
    "C200 CGI": [
      "2014",
      "2013",
      "2012",
      "2011",
      "2010"
    ],
    "C200 EQ": [
      "2018"
    ],
    "C200 K OR CGI": [
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008"
    ],
    "C200K": [
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002"
    ],
    "C230K": [
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002"
    ],
    "C250": [
      "2014",
      "2013",
      "2012",
      "2011",
      "2010"
    ],
    "C250 CGI": [
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009"
    ],
    "C300": [
      "2022",
      "2021",
      "2018",
      "2017",
      "2016"
    ],
    "C300 e": [
      "2022",
      "2020",
      "2019"
    ],
    "CLK200": [
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997"
    ],
    "CLK200K": [
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002"
    ],
    "CLK200k": [
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002"
    ],
    "CLK230": [
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997"
    ],
    "CLS400": [
      "2017",
      "2016",
      "2015"
    ],
    "E200": [
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993"
    ],
    "E200 CGI": [
      "2013",
      "2012",
      "2011",
      "2010"
    ],
    "E200EQ": [
      "2020"
    ],
    "E200K": [
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2000",
      "1999",
      "1998"
    ],
    "E250": [
      "2017",
      "2016",
      "2015",
      "2014"
    ],
    "E300": [
      "2019",
      "2017"
    ],
    "E300 e": [
      "2019"
    ],
    "E350": [
      "2023",
      "2022",
      "2021",
      "2020",
      "2019"
    ],
    "E350 EQ": [
      "2019"
    ],
    "E350 e": [
      "2020"
    ],
    "G320": [
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994"
    ],
    "G500": [
      "2019",
      "2018",
      "2017",
      "2016",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999"
    ],
    "G55AMG": [
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000"
    ],
    "G63 AMG": [
      "2019",
      "2012"
    ],
    "GLC200": [
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017"
    ],
    "GLC200EQ": [
      "2020"
    ],
    "GLC250": [
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "GLC300": [
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "GLC300 e": [
      "2020"
    ],
    "GLC350 e": [
      "2020"
    ],
    "GLE COUPE 400": [
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "GLE COUPE 43 AMG": [
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "GLE350 e": [
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "GLE400": [
      "2018",
      "2017",
      "2016"
    ],
    "GLE450": [
      "2019"
    ],
    "GLS450": [
      "2019"
    ],
    "ML320": [
      "2002",
      "2001",
      "2000",
      "1999",
      "1998"
    ],
    "ML350": [
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003"
    ],
    "ML400": [
      "2015",
      "2014"
    ],
    "ML500": [
      "2015",
      "2014",
      "2013",
      "2012",
      "2005",
      "2004",
      "2003",
      "2002"
    ],
    "S280": [
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993"
    ],
    "S300": [
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006"
    ],
    "S320": [
      "2017",
      "2016",
      "2015",
      "2014",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992"
    ],
    "S350": [
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003"
    ],
    "S350 CGI": [
      "2013",
      "2012",
      "2011"
    ],
    "S400": [
      "2018",
      "2017",
      "2016",
      "2015"
    ],
    "S400H": [
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009"
    ],
    "S450": [
      "2021",
      "2018"
    ],
    "S500": [
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994"
    ],
    "S500 CGI": [
      "2013",
      "2012",
      "2011"
    ],
    "S580": [
      "2022",
      "2020"
    ],
    "S600": [
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993"
    ],
    "SLK 200K": [
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004"
    ],
    "SLK200 CGI": [
      "2015",
      "2014",
      "2013",
      "2012"
    ],
    "SLK200/K": [
      "2000",
      "1999",
      "1998",
      "1997",
      "1996"
    ],
    "SLK200K": [
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004"
    ],
    "SLK230/K": [
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996"
    ],
    "C-Class C55": ["2007", "2006", "2005", "2004", "2003", "2002", "2001"],
    "C-Class Coupe": ["2016", "2015", "2014", "2013", "2012"],
    "C-Class Sedan": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    CL: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    CLA: ["2016", "2015", "2014"],
    CLK: ["2002", "2001", "2000", "1999"],
    CLK55: ["2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    CLS: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    "E-Class": ["2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "E-Class Convertible": ["2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    "E-Class Coupe": ["2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    "E-Class E63": ["2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "E-Class Sedan": ["2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    GL: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    ML: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    ML320: ["2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998"],
    ML430: ["2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998"],
    ML500: ["2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998"],
    "S-Class": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    SL63: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    SLK: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
  },
  Mercury: {
    Cougar: ["2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989"],
    "Grand Marquis": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    Marauder: ["2005", "2004", "2003"],
    Mariner: ["2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
    Milan: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    Montego: ["2007", "2006", "2005"],
    Mountaineer: ["2007", "2006", "2005", "2004", "2003", "2002"],
    Mystique: ["2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995"],
    Sable: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2006", "2005", "2004", "2003", "2002", "2001", "2000"],
  },
  Mitsubishi: {
    Diamante: ["2004", "2003", "2002", "1996", "1995", "1994", "1993"],
    Eclipse: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995"],
    "Eclipse Coupe": ["2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    "Eclipse Coupe SS": ["2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    Galant: ["2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994"],
    Lancer: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    "Lancer Ralliart": ["2007", "2006", "2005", "2004"],
    Montero: ["2006", "2005", "2004", "2003", "2002", "2001"],
  },
  Nissan: {
    "300ZX": ["1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990"],
    "350Z": ["2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "350Z Coupe": ["2008", "2007", "2006", "2005", "2004", "2003"],
    "350Z Roadster": ["2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "370Z": ["2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    "370Z Coupe": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    "370Z Roadster": ["2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    Altima: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2006", "2005", "2004", "2003", "2002"],
    "Altima Coupe": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    "Altima SE-R": ["2006", "2005", "2004", "2003", "2002"],
    "Altima Sedan": ["2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    Armada: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    Cube: ["2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    Juke: ["2016", "2015", "2014", "2013", "2012", "2011"],
    Maxima: ["2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000"],
    Pathfinder: ["2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
    Rogue: ["2013", "2012", "2011", "2010", "2009", "2008"],
    "Rogue Select": ["2016", "2015", "2014"],
    Sentra: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1994", "1993", "1992", "1991"],
    "Sentra SE-R": ["2012", "2011", "2010", "2009", "2008", "2007"],
    Versa: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    "Versa Hatchback": ["2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    "Versa Note": ["2016", "2015", "2014"],
    Xterra: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000"],
  },
  Pontiac: {
    "G6 Coupe": ["2010", "2009", "2008", "2007", "2006", "2005"],
    "G6 Sedan": ["2010", "2009", "2008", "2007", "2006", "2005"],
    "Grand Am": ["2005", "2004", "2003", "2002", "2001", "2000", "1999"],
    "Grand Prix": ["2003", "2002", "2001", "2000", "1999", "1998", "1997"],
    Solstice: ["2010", "2009", "2008", "2007", "2006"],
    Sunfire: ["2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995"],
    Vibe: ["2008", "2007", "2006", "2005", "2004", "2003", "2002"],
  },
  Saab: {
    9.3: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    "9.3 Vector": ["2007", "2006", "2005", "2004", "2003"],
    9.5: ["2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995"],
    900: ["2001", "2000", "1999", "1998", "1997", "1996"],
  },
  Saturn: {
    Astra: ["2010", "2009", "2008"],
    Aura: ["2010", "2009", "2008", "2007"],
    "Ion Coupe": ["2008", "2007", "2006", "2005", "2004", "2003"],
    "Ion Quad Coupe": ["2008", "2007", "2006", "2005", "2004", "2003"],
    "Ion Sedan": ["2008", "2007", "2006", "2005", "2004", "2003"],
    Outlook: ["2010", "2009", "2008", "2007"],
    SL: ["2002", "2001", "2000"],
    Sky: ["2010", "2009", "2008", "2007", "2006"],
    Vue: ["2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002"],
  },
  Scion: {
    "BR-Z": ["2016", "2015", "2014", "2013"],
    "FR-S": ["2016", "2015", "2014", "2013"],
    IQ: ["2016", "2015", "2014", "2013", "2012"],
    TC: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
    XB: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    XD: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
  },
  Subaru: {
    "BR-Z": ["2016", "2015", "2014", "2013"],
    Forester: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    Impreza: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    "Impreza WRX": ["2016", "2015", "2007", "2006", "2005", "2004", "2003", "2002"],
    Legacy: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
    "XV Crosstrek": ["2016", "2015", "2014", "2013", "2012"],
    "WRX STI": ["2017", "2016"],
  },
  Suzuki: {
    Forenza: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    "Grand Vitara": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    "SX-4": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    Verona: ["2006", "2005", "2004", "2003"],
  },
  Toyota: {
    "4Runner": ["2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    Avalon: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000"],
    Camry: [
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
    ],
    Celica: ["2005", "2004", "2003", "2002", "2001", "2000"],
    Corolla: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998"],
    Echo: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000"],
    "GT-86": ["2016", "2015", "2014", "2013", "2012"],
    Highlander: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001"],
    "MR2 Spyder": ["2005", "2004", "2003", "2002", "2001", "2000"],
    Matrix: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    Sequoia: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001"],
    Sienna: ["2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    Solara: ["2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999"],
    Tundra: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "Yaris Hatchback": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "Yaris Sedan": ["2011", "2010", "2009", "2008", "2007"],
  },
  Volkswagen: {
    Beetle: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998"],
    CC: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    EOS: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    Jetta: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999"],
    Passat: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998"],
    Touareg: ["2007", "2006", "2005", "2004", "2003"],
  },
  Volvo: {
    850: ["1998", "1997", "1996", "1995", "1994"],
    S40: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000"],
    S60: ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    S70: ["2000", "1999", "1998"],
  },
};
// Two-level version (Make → Models only, no years)
let makeObjectSimple = {
  Acura: ["ILX", "Integra", "RL", "RSX", "TL", "TLX", "TSX"],
  Audi: ["A4", "A6"],
  BMW: ["3-Series 2DR", "3-Series 4DR", "318TI", "5-Series", "Z4"],
  Buick: ["Century", "Lacrosse", "Lucerne", "Regal"],
  Cadillac: ["ATS", "CTS Coupe", "CTS Sedan", "Catera", "Deville DTS", "El Dorado", "Escalade", "STS"],
  Chevrolet: ["Aveo", "Beretta", "C1500", "Camaro", "Camaro Z28", "Cavalier Z24", "Cobalt 2DR", "Cobalt 4DR", "Corvette C5", "Corvette C6", "Corvette C7", "Cruze", "Equinox", "HHR", "Impala", "Malibu", "Malibu Maxx", "Prizm", "SSR", "Silverado", "Suburban", "Tahoe", "Trailblazer"],
  Chrysler: ["200", "300", "300M", "Aspen", "Concorde", "PT Cruiser", "Sebring", "Town and Country"],
  Dodge: ["Avenger", "Caliber", "Caravan", "Challenger", "Charger", "Charger 500", "Charger Daytona", "Dart", "Durango", "Intrepid", "Neon", "Nitro", "Ram", "Stratus"],
  Fiat: ["500"],
  Ford: ["Five Hundred", "Contour", "Crown Victoria", "Escape", "Expedition", "Explorer", "Flex", "F-150", "Fiesta", "Focus", "Fusion", "F-150 Lightning", "Mustang", "Mustang GT", "Mustang GT350R", "Mustang GT500", "Taurus", "Thunderbird"],
  GMC: ["Denali", "Envoy", "Sierra", "Tahoe", "Yukon"],
  Honda: ["Accord 2DR", "Accord 4DR", "CRV", "Civic 2DR", "Civic 4DR", "Del Sol", "Element", "S2000"],
  Hummer: ["H2", "H3"],
  Hyundai: ["Accent", "Azera", "Elantra", "Elantra Touring", "Genesis 2DR", "Genesis 4DR", "Genesis Hood Scoop", "Santa Fe", "Sonata", "Tiburon", "Tiburon GT-V6", "Tucson"],
  Infiniti: ["G20", "G35 2DR", "G35 4DR", "G37 2DR", "G37 4DR", "G37 Side Scoops", "M35", "M37", "M45", "Q50", "Q70", "QX56", "I30", "I35"],
  Jaguar: ["S-Type R", "XF"],
  Jeep: ["Grand Cherokee", "Liberty", "Patriot"],
  Kia: ["Amanti", "Cadenza", "Forte Koup", "Forte Koup-R", "Forte Sedan", "Optima", "Rio", "Rondo", "Sedona", "Soul", "Sorento", "Spectra", "Sportage"],
  "Land Rover": ["Range Rover", "Range Rover Sport"],
  Lexus: ["ES", "GS", "GS300", "GS400", "GX470", "IS", "IS250", "IS300", "LS460", "LX470", "RC", "RX300"],
  Lincoln: ["Continental", "LS", "MKS", "MKZ", "Navigator", "Navigator Hood Scoop", "Zephyr"],
  Mazda: ["CX-7", "MPV", "Mazda 3", "Mazda 5 Hatchback", "Mazda 6", "Mazda 626", "Miata MX-5", "Protege MP3", "RX-8", "Tribute"],
  "Mercedes Benz": ["200E", "C180", "C180 CGI", "C180K", "C200", "C200 CGI", "C200 EQ", "C200 K OR CGI", "C200K", "C230K", "C250", "C250 CGI", "C300", "C300 e", "CLK200", "CLK200K", "CLK200k", "CLK230", "CLS400", "E200", "E200 CGI", "E200EQ", "E200K", "E250", "E300", "E300 e", "E350", "E350 EQ", "E350 e", "G320", "G500", "G55AMG", "G63 AMG", "GLC200", "GLC200EQ", "GLC250", "GLC300", "GLC300 e", "GLC350 e", "GLE COUPE 400", "GLE COUPE 43 AMG", "GLE350 e", "GLE400", "GLE450", "GLS450", "ML320", "ML350", "ML400", "ML500", "S280", "S300", "S320", "S350", "S350 CGI", "S400", "S400H", "S450", "S500", "S500 CGI", "S580", "S600", "SLK 200K", "SLK200 CGI", "SLK200/K", "SLK200K", "SLK230/K", "C-Class C55", "C-Class Coupe", "C-Class Sedan", "CL", "CLA", "CLK", "CLK55", "CLS", "E-Class", "E-Class Convertible", "E-Class Coupe", "E-Class E63", "E-Class Sedan", "GL", "ML", "ML320", "ML430", "ML500", "S-Class", "SL63", "SLK"],
  Mercury: ["Cougar", "Grand Marquis", "Marauder", "Mariner", "Milan", "Montego", "Mountaineer", "Mystique", "Sable"],
  Mitsubishi: ["Diamante", "Eclipse", "Eclipse Coupe", "Eclipse Coupe SS", "Galant", "Lancer", "Lancer Ralliart", "Montero"],
  Nissan: ["300ZX", "350Z", "350Z Coupe", "350Z Roadster", "370Z", "370Z Coupe", "370Z Roadster", "Altima", "Altima Coupe", "Altima SE-R", "Altima Sedan", "Armada", "Cube", "Juke", "Maxima", "Pathfinder", "Rogue", "Rogue Select", "Sentra", "Sentra SE-R", "Versa", "Versa Hatchback", "Versa Note", "Xterra"],
  Pontiac: ["G6 Coupe", "G6 Sedan", "Grand Am", "Grand Prix", "Solstice", "Sunfire", "Vibe"],
  Saab: ["9.3", "9.3 Vector", "9.5", "900"],
  Saturn: ["Astra", "Aura", "Ion Coupe", "Ion Quad Coupe", "Ion Sedan", "Outlook", "SL", "Sky", "Vue"],
  Scion: ["BR-Z", "FR-S", "IQ", "TC", "XB", "XD"],
  Subaru: ["BR-Z", "Forester", "Impreza", "Impreza WRX", "Legacy", "XV Crosstrek", "WRX STI"],
  Suzuki: ["Forenza", "Grand Vitara", "SX-4", "Verona"],
  Toyota: ["4Runner", "Avalon", "Camry", "Celica", "Corolla", "Echo", "GT-86", "Highlander", "MR2 Spyder", "Matrix", "Sequoia", "Sienna", "Solara", "Tundra", "Yaris Hatchback", "Yaris Sedan"],
  Volkswagen: ["Beetle", "CC", "EOS", "Jetta", "Passat", "Touareg"],
  Volvo: ["850", "S40", "S60", "S70"]
};

let makeClassModel = {
  BMW: {
    "3-Series (1992-1998)": ["320", "325"],
    "3-Series (1999-2006)": ["316", "318", "320"],
    "3-Series (2007-2011)": ["316", "318", "320", "323", "325"],
    "3-Series (2012-2019)": ["316", "318", "320", "330", "330e Plug in"],
    "3-Series (2020-2026)": ["318", "320","330e Plug in"],
    "5-Series (1988-1995)": ["520", "525"],
    "5-Series (1996-2003)": ["520", "523", "525","528", "530"],
    "5-Series (2004-2010)": ["520", "523", "525","528", "530"],
    "5-Series (2011-2016)": ["520", "523","528", "530"],
    "5-Series (2017-2024)": ["520", "520e Plug In","530", "530 Plug In"],
    "X5 (2000-2006)": ["3.0i", "4.4i"],
    "X5 (2007-2013)": ["xdrive 35i", "xdrive 48i" , "xdrive 50i"],
    "X5 (2014-2018)": ["xdrive 35i", "xdrive 40e Plug In" , "xdrive 50i"],
    "X5 (2019-2026)": ["xdrive 40i", "xdrive 45e Plug In" , "xdrive 50e Plug In", "xdrive 50i"],
    "7-Series (1995-2001)": ["730", "735", "740"],
    "7-Series (2001-2008)": ["730", "730", "735","740", "745"],
    "7-Series (2008-2015)": ["730", "740", "Active Hybrid 7", "750", "760"],
    "7-Series (2016-2022)": ["730", "740", "740e Plug In", "745e Plug In"],
    "7-Series (2022-2026)": ["740"],
    "X3": ["2.5 si", "3.0 si", "xdrive 25i", "xdrive 30i"],
    "X1 (2016-2022)": ["20i"],
    "i3": ["i3"],
  },
  Cadillac: {
    "ATS": ["ATS"],
    "CTS": ["CTS Sedan"],
    "CT6": ["CT6"],
    "Escalade": ["Escalade"],
    "SRX": ["SRX"],
    "XT4": ["XT4"],
    "XT5": ["XT5"],
    "XT6": ["XT6"],
    "DTS": ["DTS"],
    "STS": ["STS"],
    "XTS": ["XTS"],
  },
  Chevrolet: {
    "Avalanche": ["Avalanche"],
    "Camaro": ["Camaro"],
    "Captiva": ["Captiva"],
    "Corvette": ["Corvette"],
    "Colorado": ["Colorado"],
    "Cruze": ["Cruze"],
    "Equinox": ["Equinox"],
    "Impala": ["Impala"],
    "Malibu": ["Malibu"],
    "Traverse": ["Traverse"],
    "Spark": ["Spark"],
    "Silverado": ["Silverado"],
    "Suburban": ["Suburban"],
    "Tahoe": ["Tahoe"],
    "Trailblazer": ["Trailblazer"],
  },
  Chrysler: {
    "300C": ["300C"],
    "300": ["300"],
    "Sebring": ["Sebring"],
    "Town and Country": ["Town and Country"],
  },
  Dodge: {
    "Caliber": ["Caliber"],
    "Challenger": ["Challenger"],
    "Charger": ["Charger"],
    "Durango": ["Durango"],
    "Nitro": ["Nitro"],
    "Ram": ["Ram Gasoline", "Ram Diesel"],
  },
  Ford: {
    "Escape": ["Escape Hybrid"],
    "Expedition": ["Expedition"],
    "Explorer": ["Explorer"],
    "Edge": ["Edge"],
    "F-150": ["F-150"],
    "Fusion": ["Fusion Hybrid"],
    "Mustang": ["Mustang"],
    "Taurus": ["Taurus"],
    "Cmax": ["Cmax"],
  },
  GMC: {
    "Terrian": ["Terrian"],
    "Envoy": ["Envoy"],
    "Sierra": ["Sierra"],
    "Acadia": ["Acadia"],
    "Yukon": ["Yukon"],
    "Savana": ["Savana"],
    "Canyon": ["Canyon"],
    
  },
  Jeep: {
    "Grand Cherokee": ["Grand Cherokee"],
    "Wrangler": ["Wrangler"],
    "Compass": ["Compass"],
    "Patriot": ["Partiot"],
    "Commander": ["Commander"],
  },
  Lincoln: {
    "MKZ": ["MKZ Hybrid"],
    "Navigator": ["Navigator"],
  },
  "Mercedes Benz": {
    "C-Class": ["190", "C180", "C180 CGI", "C180 Kompressor", "C200", "C200 CGI", "C200 Mild Hybrid", "C200 Kompressor", "C230 Kompressor", "C250", "C250 CGI", "C300", "C300 e Plug in"],
    "E-Class": ["E200", "200E", "E200 CGI", "E200 Mild Hybrid", "E200 Kompressor", "E250", "E300", "E300e Plug in", "E300 Mild Hybrid", "E350 Mild Hybrid"],
    "S-Class": ["S280", "S320", "S350", "S300", "S350 CGI", "S400", "S400 Hybrid", "S450", "S500", "S500 CGI", "S580", "S600"],
    "CLA-Class": ["CLA45 AMG"],
    "CLK-Class": ["CLK200", "CLK200 Kompressor", "CLK230"],
    "CLS-Class": ["CLS400"],
    "G-Class": ["G320", "G500", "G55 AMG", "G63 AMG"],
    "GLC-Class": ["GLC200", "GLC200 Mild Hybrid", "GLC250", "GLC300", "GLC300e Plug in", "GLC350e Plug in"],
    "GLE-Class": ["GLE COUPE 400", "GLE COUPE 43 AMG", "GLE350", "GLE400", "GLE450"],
    "GLS-Class": ["GLS450"],
    "ML-Class": ["ML320", "ML350", "ML400", "ML500"],
    "B-Class": ["B250"],
    "SLK-Class": ["SLK 200", "SLK200 CGI", "SLK200 Kompressor", "SLK230", "SLK230 Kompressor"]
  },
};